module.exports = __webpack_public_path__ + "static/Nuria-ca7d281f484da6a7bba109bab02526a8.jpg";